import {BrowserModule} from '@angular/platform-browser'
import {NgModule} from '@angular/core'
import {HeaderModule} from './header/header.module'
import {PersistanceService} from './persistance/persistance.service'

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    HeaderModule,
  ],
  providers: [
    PersistanceService
  ],
})
export class CoreModule {}
